import { render, staticRenderFns } from "./interactDetail.vue?vue&type=template&id=ddf346d2&scoped=true&"
import script from "./interactDetail.vue?vue&type=script&lang=js&"
export * from "./interactDetail.vue?vue&type=script&lang=js&"
import style0 from "./interactDetail.vue?vue&type=style&index=0&id=ddf346d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf346d2",
  null
  
)

export default component.exports